<div class="row mx-0 my-2 p-0">
  <div class="col-12 m-0 p-0 home-tab-selection">
    <kendo-tabstrip (tabSelect)="onTabSelect($event)">
      <!-- <kendo-tabstrip-tab [title]="'P6 Projects'">
        <ng-template kendoTabContent>
        </ng-template>
      </kendo-tabstrip-tab> -->
      <kendo-tabstrip-tab [title]="'OeAM Hierachy'" [selected]="true">
        <ng-template kendoTabContent>
          <app-oeam-hierarchy></app-oeam-hierarchy>
        </ng-template>
      </kendo-tabstrip-tab>
      <!-- <kendo-tabstrip-tab [title]="'Assigned Position'"></kendo-tabstrip-tab> -->
    </kendo-tabstrip>
  </div>
</div>